/* Just Natural — recipe section JS: tab switcher + ingredient cart adds.
   Reuses the theme's UpCart drawer (window.UpCart) the same way the custom
   product cards do. No product lookups here — variant ids/availability are
   written onto the rows in Liquid. */
(function () {
  'use strict';

  /* ---------- Tabs (Ingredients / Instructions) ---------- */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function select(tab) {
      tabs.forEach(function (t) {
        var selected = t === tab;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.tabIndex = selected ? 0 : -1;
        t.classList.toggle('is-active', selected);
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var dir = e.key === 'ArrowRight' ? 1 : -1;
          var next = tabs[(i + dir + tabs.length) % tabs.length];
          next.focus();
          select(next);
        }
      });
    });
  }

  /* ---------- Cart ---------- */
  function refreshCartUI() {
    if (window.UpCart && typeof window.UpCart.open === 'function') {
      window.UpCart.open();
      return;
    }
    // Fallback: bump any native cart bubbles.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {});
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) { return res.json().then(function (e) { throw e; }); }
      return res.json();
    });
  }

  function flashAdded(btn) {
    btn.classList.add('is-added');
    setTimeout(function () { btn.classList.remove('is-added'); }, 1200);
  }

  function initCart(root) {
    // Single line add (event delegation).
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.recipe-ing__add');
      if (!btn || btn.disabled) return;
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      btn.disabled = true;
      btn.classList.add('is-loading');
      addItems([{ id: Number(id), quantity: 1 }])
        .then(function () { flashAdded(btn); refreshCartUI(); })
        .catch(function () {})
        .finally(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
    });

    // Add All To Cart.
    var addAll = root.querySelector('[data-recipe-addall]');
    if (addAll) {
      var note = root.querySelector('[data-recipe-addall-note]');
      addAll.addEventListener('click', function () {
        var rows = Array.prototype.slice.call(root.querySelectorAll('.recipe-ing--buyable[data-variant-id][data-available="true"]'));
        if (!rows.length) return;
        var seen = {};
        var items = [];
        rows.forEach(function (row) {
          var id = row.getAttribute('data-variant-id');
          if (id && !seen[id]) { seen[id] = true; items.push({ id: Number(id), quantity: 1 }); }
        });
        if (!items.length) return;
        addAll.disabled = true;
        addAll.classList.add('is-loading');
        if (note) { note.hidden = true; note.textContent = ''; }
        addItems(items)
          .then(function () { refreshCartUI(); })
          .catch(function () {
            if (note) { note.textContent = 'Sorry, these ingredients could not be added right now.'; note.hidden = false; }
          })
          .finally(function () { addAll.disabled = false; addAll.classList.remove('is-loading'); });
      });
    }
  }

  /* ---------- Show more (category grids) ---------- */
  function initShowMore(btn) {
    var grid = document.querySelector(btn.getAttribute('data-target'));
    if (!grid) return;
    var step = parseInt(btn.getAttribute('data-step'), 10) || 20;
    btn.addEventListener('click', function () {
      var hidden = Array.prototype.slice.call(grid.querySelectorAll('.recipe-card[hidden]'));
      hidden.slice(0, step).forEach(function (c) { c.hidden = false; });
      if (!grid.querySelector('.recipe-card[hidden]')) btn.hidden = true;
    });
  }

  /* ---------- Random recipe button ---------- */
  function initRandom() {
    var list = document.querySelector('[data-recipe-random-list]');
    var btn = document.querySelector('[data-recipe-random]');
    if (!list || !btn) return;
    var urls = [];
    try { urls = JSON.parse(list.textContent) || []; } catch (e) {}
    if (!urls.length) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = urls[Math.floor(Math.random() * urls.length)];
      if (url) window.location.href = url;
    });
  }

  /* ---------- Drag-to-scroll carousels (mouse; touch scrolls natively) ---------- */
  function initDragScroll(el) {
    var down = false, startX = 0, startScroll = 0, moved = false, captured = false, pid = null;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // let touch use native momentum scroll
      down = true; moved = false; captured = false; pid = e.pointerId;
      startX = e.clientX; startScroll = el.scrollLeft;
      // NB: do NOT capture the pointer here — capturing on pointerdown swallows
      // plain clicks on the cards. Capture only once a real drag begins (below).
    });
    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4 && !captured) {
        moved = true;
        if (el.setPointerCapture) { try { el.setPointerCapture(pid); } catch (err) {} }
        captured = true;
        el.classList.add('is-dragging');
      }
      if (moved) el.scrollLeft = startScroll - dx;
    });
    function end() { down = false; captured = false; el.classList.remove('is-dragging'); }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    // Swallow the click that follows a drag so cards don't navigate mid-drag.
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function init() {
    initRandom();
    document.querySelectorAll('.recipe-carousel').forEach(function (c) { initDragScroll(c); });
    document.querySelectorAll('[data-recipe-main]').forEach(function (main) {
      initTabs(main);
    });
    document.querySelectorAll('[data-recipe-cart-root]').forEach(function (root) {
      initCart(root);
    });
    document.querySelectorAll('[data-recipe-showmore-btn]').forEach(function (btn) {
      initShowMore(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
